module.exports = __webpack_public_path__ + "static/media/IMG_20191127_125159.c29a6a3e.jpg";